// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_w0-8";
export var editMode = "_w0-3";
export var headerRow = "_w0-a";
export var headerTitle = "_w0-b";
export var product = "_w0-1";
export var productDetails = "_w0-5";
export var productDivider = "_w0-7";
export var productImage = "_w0-2";
export var productInfo = "_w0-4";
export var productTitle = "_w0-6";
export var strikethrough = "_w0-9";
export var upsellProductsCard = "_w0-0";